import script from "./esDailyCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./esDailyCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./esDailyCalendar.vue?vue&type=style&index=0&id=06f5b486&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f5b486"]])

export default __exports__